var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidenav"},[_c('div',{staticClass:"login-main-text"},[_c('center',[_c('img',{attrs:{"alt":"Vue logo","src":require("../assets/logo.png")}}),_c('h2',[_vm._v(" Welcome to "),_c('br'),_vm._v(" NS Handy CRM ")])])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }